import { Image } from "@components/Image/Image";
import ModalsPopup from "@components/Modals/ModalsPopup";
import { StyledButton } from "@components/Styled/Button";
import { ImageWrapper } from "@components/Styled/Image";
import { styledWithInvalidProps } from "@components/Styled/StyledWithInvalidProps";
import { StyledH5 } from "@components/Styled/Text";
import React from "react";
import tw from "twin.macro";
import { FeaturesOutputProps, withFeatures } from "./withFeatures";

type ModalTriggerProps = {
  hasModal: boolean;
  current: boolean;
};

const Container = tw.div`mt-1`;
const Buttons = tw.div`
  grid grid-cols-2 gap-mini auto-rows-fr mb-midi md:grid-cols-1 xl:grid-cols-2
`;
const Content = tw.div`
  p-maxi text-body bg-white md:p-6
`;
const Label = styledWithInvalidProps("span")(
  ({ hasModal }: { hasModal: boolean }) => [
    `flex-1`,
    hasModal
      ? tw`underline underline-offset-4 text-primary hover:text-secondary`
      : tw``,
  ],
);

const Title = tw(StyledH5)`
  flex
`;
const ModalTrigger = styledWithInvalidProps(StyledButton)(
  ({ hasModal }: ModalTriggerProps) => [
    tw`w-full p-zero flex flex-row justify-start text-caption text-black text-left leading-caption md:text-hint`,
    hasModal ? tw`cursor-pointer` : tw`cursor-auto`,
  ],
);

const Icon = tw.img`
  w-midi h-midi
`;

const ModalImage = tw(Image)`
  w-full
`;

export const Features = withFeatures(
  ({
    features,
    active,
    activeFeature,
    setActive,
    onClick,
  }: FeaturesOutputProps) => (
    <Container>
      <Buttons>
        {features?.map((feature) => (
          <ModalTrigger
            key={feature?._key}
            hasModal={feature?.hasModal}
            onClick={onClick(feature?._key)}
            height="32"
            className="tracking-pdp-feature"
          >
            <Icon src={feature?.icon?.asset?.url} alt={feature?.icon?.alt} />
            <Label hasModal={feature?.hasModal}>{feature?.title}</Label>
          </ModalTrigger>
        ))}
      </Buttons>
      <ModalsPopup layout="upsell" active={active} setActive={setActive}>
        <>
          <Content data-testid="feature-modal">
            <Title>
              {activeFeature?.modalIcon && (
                <Icon
                  src={activeFeature?.modalIcon?.asset?.url}
                  alt={activeFeature?.modalIcon?.alt}
                />
              )}
              {activeFeature?.title}
            </Title>
            <div className="rte">{activeFeature?.modalContent}</div>
          </Content>
          {activeFeature?.modalImage && (
            <ImageWrapper>
              <ModalImage image={activeFeature?.modalImage} ratio="16/9" />
            </ImageWrapper>
          )}
        </>
      </ModalsPopup>
    </Container>
  ),
);
